import { Capacitor } from "@capacitor/core";

export const isNative = (): boolean => Capacitor.isNativePlatform();
export const platform = (): "ios" | "android" | "web" => Capacitor.getPlatform() as "ios" | "android" | "web";

/** True for an iOS home-screen PWA (Safari's standalone mode), which cannot keep OAuth redirects in-app. */
export const isStandalonePwa = (): boolean =>
  typeof window !== "undefined" &&
  !isNative() &&
  ((window.navigator as unknown as { standalone?: boolean }).standalone === true ||
    window.matchMedia?.("(display-mode: standalone)").matches);
